import { render, staticRenderFns } from "./MallRecord.vue?vue&type=template&id=73b2ef8c&scoped=true&"
import script from "./MallRecord.vue?vue&type=script&lang=js&"
export * from "./MallRecord.vue?vue&type=script&lang=js&"
import style0 from "./MallRecord.vue?vue&type=style&index=0&id=73b2ef8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b2ef8c",
  null
  
)

export default component.exports